module.exports = "/_next/static/images/07b00883db943855c9fefb3fd3846c64-mb-hero-xs.jpg";